module.exports = __webpack_public_path__ + "img/7.178de352.jpg";